import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useShowInactiveObservables = createGlobalState({
  key: "showInactiveObservables",
  storage: "session",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
